import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { Mail, Github, Linkedin, Instagram, Send, MapPin, Phone, Sparkles, Heart } from "lucide-react";
import { contactAPI } from '../services/api';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState('');

  // Perbaikan: konsisten gunakan handleChange
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const sendEmail = async (data) => {
  try {
    const service =
      (typeof import.meta !== 'undefined' && import.meta.env?.VITE_EMAILJS_SERVICE) ||
      process.env.REACT_APP_EMAILJS_SERVICE ||
      'service_default';
    const template =
      (typeof import.meta !== 'undefined' && import.meta.env?.VITE_EMAILJS_TEMPLATE) ||
      process.env.REACT_APP_EMAILJS_TEMPLATE ||
      'template_default';
    const publicKey =
      (typeof import.meta !== 'undefined' && import.meta.env?.VITE_EMAILJS_PUBLIC) ||
      process.env.REACT_APP_EMAILJS_PUBLIC ||
      'public_default';

    await emailjs.send(service, template, data, publicKey);
    console.log('EmailJS success');
  } catch (err) {
    console.error('EmailJS failed:', err);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      await contactAPI.submitContact(formData);
      await sendEmail({
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message
      });
      setStatus('Pesan berhasil dikirim!');
      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
      console.error(err);
      setStatus('Terjadi error, coba lagi.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const socialLinks = [
    {
      name: 'Email',
      icon: Mail,
      url: 'mailto:kinandaru@gmail.com',
      color: 'text-[#3A7CA5] hover:text-[#2E6B94]',
      bg: 'hover:bg-[#3A7CA5]/10',
      borderColor: 'hover:border-[#3A7CA5]',
      gradient: 'from-[#3A7CA5] to-[#2E6B94]'
    },
    {
      name: 'GitHub',
      icon: Github,
      url: 'https://github.com/kinanprastiwi',
      color: 'text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white',
      bg: 'hover:bg-gray-100 dark:hover:bg-gray-700',
      borderColor: 'hover:border-gray-400 dark:hover:border-gray-500',
      gradient: 'from-gray-700 to-black'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: 'https://www.linkedin.com/in/kinandaru-pramudya-prastiwi/',
      color: 'text-blue-600 hover:text-blue-700',
      bg: 'hover:bg-blue-50 dark:hover:bg-blue-900/20',
      borderColor: 'hover:border-blue-500',
      gradient: 'from-blue-600 to-blue-700'
    },
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/kinandaru_1/',
      color: 'text-pink-500 hover:text-pink-600',
      bg: 'hover:bg-pink-50 dark:hover:bg-pink-900/20',
      borderColor: 'hover:border-pink-400',
      gradient: 'from-pink-500 to-purple-500'
    }
  ];

  return (
    <section id="contact" className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-slideInUp">
          <div className="flex items-center justify-center gap-2 mb-4 group">
            <Mail className="w-8 h-8 text-[#3A7CA5] dark:text-[#A9D6E5] group-hover:rotate-12 transition-transform duration-300" />
            <h2 className="text-4xl font-bold text-[#3D3D3D] dark:text-white hover:gradient-text transition-all duration-300">
              Hubungi Saya
            </h2>
            <Sparkles className="w-6 h-6 text-[#E6B566] animate-pulse" />
          </div>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3A7CA5] to-[#E6B566] mx-auto mb-6 hover:w-32 transition-all duration-500"></div>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Tertarik untuk berkolaborasi? Punya ide proyek? Mari terhubung dan wujudkan sesuatu yang luar biasa bersama!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <div className="space-y-8 animate-slideInLeft">
            <div>
              <h3 className="text-2xl font-bold text-[#3D3D3D] dark:text-white mb-6 flex items-center gap-2">
                Mari Memulai Pertemanan
                <Heart className="w-6 h-6 text-[#E6B566] animate-bounce-slow" />
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-8">
                Saya senang berdiskusi mengenai peluang baru, kolaborasi dalam proyek inovatif, 
                atau sekadar berbincang tentang teknologi dan desain. Silakan hubungi saya melalui saluran berikut.
              </p>
            </div>

            {/* Contact Details */}
            <div className="space-y-6">
              {[{
                icon: Mail,
                title: "Email",
                content: <a href="mailto:kinandaru@gmail.com" className="text-gray-600 dark:text-gray-400 hover:text-[#3A7CA5] dark:hover:text-[#A9D6E5] transition-colors duration-200">kinandaru@gmail.com</a>,
                color: "text-[#3A7CA5]",
                bgColor: "bg-[#3A7CA5]/10"
              },{
                icon: MapPin,
                title: "Location",
                content: <p className="text-gray-600 dark:text-gray-400">Jakarta, Indonesia</p>,
                color: "text-[#E6B566]",
                bgColor: "bg-[#E6B566]/10"
              },{
                icon: Phone,
                title: "Response Time",
                content: <p className="text-gray-600 dark:text-gray-400">Usually within 24 hours</p>,
                color: "text-[#A9D6E5]",
                bgColor: "bg-[#A9D6E5]/20"
              }].map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="flex items-center gap-4 group animate-slideInLeft hover:translate-x-2 transition-all duration-300">
                    <div className={`w-12 h-12 ${item.bgColor} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300 relative`}>
                      <IconComponent className={`w-6 h-6 ${item.color} group-hover:rotate-12 transition-transform duration-300`} />
                      <div className="absolute inset-0 border border-current rounded-lg opacity-0 group-hover:opacity-30 group-hover:scale-125 transition-all duration-300"></div>
                    </div>
                    <div>
                      <p className="font-medium text-[#3D3D3D] dark:text-white group-hover:text-[#3A7CA5] dark:group-hover:text-[#A9D6E5] transition-colors duration-200">{item.title}</p>
                      {item.content}
                    </div>
                  </div>
                )
              })}
            </div>

            {/* Social Links */}
            <div className="animate-slideInLeft animation-delay-500">
              <p className="font-medium text-[#3D3D3D] dark:text-white mb-4 flex items-center gap-2">
                Hubungi saya
                <Sparkles className="w-4 h-4 text-[#E6B566] animate-pulse" />
              </p>
              <div className="flex gap-4">
                {socialLinks.map((social, index) => {
                  const IconComponent = social.icon;
                  return (
                    <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer"
                      className={`relative w-12 h-12 rounded-lg border border-gray-200 dark:border-gray-700 flex items-center justify-center transition-all duration-300 transform hover:scale-125 hover:rotate-12 ${social.color} ${social.bg} ${social.borderColor} group glow-on-hover animate-fadeInScale`}
                      style={{ animationDelay: `${index * 100}ms` }}
                    >
                      <IconComponent className="w-5 h-5 relative z-10" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${social.gradient} rounded-lg opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                      <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-800 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">{social.name}</div>
                    </a>
                  )
                })}
              </div>
            </div>
          </div>

          {/* Enhanced Contact Form */}
          <div className="bg-[#F8F9FA] dark:bg-gray-800 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 card-hover animate-slideInRight glow-on-hover">
            <h3 className="text-2xl font-bold text-[#3D3D3D] dark:text-white mb-6 flex items-center gap-2">
              Kirim Saya Sebuah Pesan
              <Send className="w-6 h-6 text-[#3A7CA5] dark:text-[#A9D6E5]" />
            </h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="group">
                <label htmlFor="name" className="block text-sm font-medium text-[#3D3D3D] dark:text-white mb-2 group-focus-within:text-[#3A7CA5] dark:group-focus-within:text-[#A9D6E5] transition-colors duration-200">
                  Nama Anda
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg focus:ring-2 focus:ring-[#3A7CA5] dark:focus:ring-[#A9D6E5] focus:border-transparent outline-none transition-all duration-300 hover:border-[#3A7CA5]/50 dark:hover:border-[#A9D6E5]/50"
                  placeholder="Enter your full name"
                />
              </div>

              <div className="group">
                <label htmlFor="email" className="block text-sm font-medium text-[#3D3D3D] dark:text-white mb-2 group-focus-within:text-[#3A7CA5] dark:group-focus-within:text-[#A9D6E5] transition-colors duration-200">
                  Email Anda
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg focus:ring-2 focus:ring-[#3A7CA5] dark:focus:ring-[#A9D6E5] focus:border-transparent outline-none transition-all duration-300 hover:border-[#3A7CA5]/50 dark:hover:border-[#A9D6E5]/50"
                  placeholder="Enter your email address"
                />
              </div>

              <div className="group">
                <label htmlFor="message" className="block text-sm font-medium text-[#3D3D3D] dark:text-white mb-2 group-focus-within:text-[#3A7CA5] dark:group-focus-within:text-[#A9D6E5] transition-colors duration-200">
                  Pesan Anda
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg focus:ring-2 focus:ring-[#3A7CA5] dark:focus:ring-[#A9D6E5] focus:border-transparent outline-none resize-none transition-all duration-300 hover:border-[#3A7CA5]/50 dark:hover:border-[#A9D6E5]/50"
                  placeholder="Tell me about your project or just say hello!"
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#3A7CA5] to-[#2E6B94] text-white py-3 rounded-lg font-medium hover:shadow-2xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed relative overflow-hidden group"
              >
                <span className="relative z-10 flex items-center gap-2">
                  {isSubmitting ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Mengirim Secara Ajaib...
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4 group-hover:rotate-12 transition-transform duration-200" />
                      Kirim Pesan
                    </>
                  )}
                </span>
                
                {/* Button animation background */}
                <div className="absolute inset-0 bg-gradient-to-r from-[#2E6B94] to-[#3A7CA5] transform translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
              </button>
               {status && <p className="mt-4 text-center">{status}</p>}
            </form>
          </div>
        </div>

        {/* Enhanced Call to Action */}
        <div className="mt-20 text-center animate-slideInUp animation-delay-700">
          <div className="bg-gradient-to-r from-[#3A7CA5]/10 to-[#E6B566]/10 dark:from-[#3A7CA5]/20 dark:to-[#E6B566]/20 rounded-2xl p-8 hover:shadow-2xl transition-all duration-500 transform hover:scale-105 group">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Sparkles className="w-6 h-6 text-[#E6B566] animate-pulse" />
              <h3 className="text-2xl font-bold text-[#3D3D3D] dark:text-white group-hover:gradient-text transition-all duration-300">
                Siap mewujudkan ide Anda?
              </h3>
              <Heart className="w-6 h-6 text-[#E6B566] animate-bounce-slow" />
            </div>
            <p className="text-gray-600 dark:text-gray-300 mb-6 max-w-2xl mx-auto">
              Apakah Anda membutuhkan website, aplikasi mobile, atau desain UI/UX, saya siap membantu menciptakan solusi yang berdampak nyata.
            </p>
            <a
              href="mailto:kinandaru@gmail.com"
              className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-[#3A7CA5] to-[#2E6B94] text-white rounded-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110 hover:rotate-1 relative overflow-hidden group/cta"
            >
              <span className="relative z-10 flex items-center gap-2">
                <Mail className="w-5 h-5 group-hover/cta:rotate-12 transition-transform duration-200" />
                Memulai Projek
              </span>
              
              {/* Button glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#2E6B94] to-[#E6B566] transform translate-y-full group-hover/cta:translate-y-0 transition-transform duration-300"></div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;